import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'DiveConnect - Discover Amazing Scuba Diving Trips Worldwide',
  description = 'Book unforgettable scuba diving trips to the world\'s best dive sites. Expert-led adventures in the Maldives, Red Sea, Indonesia, and more. Join DiveConnect today!',
  keywords = 'scuba diving trips, dive vacations, diving holidays, dive sites, underwater adventure, diving tours, scuba travel',
  image = '/logo512.png',
  url,
  type = 'website',
  author = 'DiveConnect'
}) => {
  // Use current URL if not provided
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  
  // Ensure image is absolute URL
  const imageUrl = image.startsWith('http') 
    ? image 
    : `${window.location.origin}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={imageUrl} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

export default SEO;
